import React from "react";
import GlobalStyle from "./GlobalStyle";
import styled from "styled-components";
import Theme from "./components/Theme";
import About from "./components/About";
import Speakers from "./components/Speakers";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Movie from "./components/Movie";
import Map from "./components/Map";
import Booth from "./components/Booth";
import Schedule from "./components/Schedule";
import device from "./helpers/device";
import Store from "./Store";
import { BrowserRouter } from "react-router-dom";
import LazyLoad from "react-lazyload";

export default function() {
  return (
    <BrowserRouter>
      <Wrapper>
        <GlobalStyle />
        <Hero />
        <Contents>
          <ContentsInner>
            <Theme />
            <LazyLoad>
              <Movie />
            </LazyLoad>
            <About />
            <LazyLoad>
              <Speakers />
            </LazyLoad>
            <Store render={store => <Schedule store={store} />} />
            <LazyLoad>
              <Map />
            </LazyLoad>
            <Store render={store => <Booth store={store} />} />
            <Footer />
          </ContentsInner>
        </Contents>
      </Wrapper>
    </BrowserRouter>
  );
}

const Wrapper = styled.div`
  height: 100%;
`;

const Contents = styled.div`
  &:before {
    content: "";
    display: block;
    height: 100%;
  }
  height: 100%;
  position: relative;
  @media ${device.mobileL} {
  }
`;

const ContentsInner = styled.div`
  background: #fff;
  width: calc(100% - 20px);
  margin: 0 auto 50px auto;
  border-radius: 20px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  @media ${device.mobileL} {
    max-width: 1000px;
  }
`;
